"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let ProductPrice = class ProductPrice extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    product;
    onProduct(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("product");
    }
    is_purchase_price;
    onIs_purchase_price(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("is_purchase_price");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    item;
    async $$load_item() {
        return this.oid
            ? this.$fn.fetch('read_product_price', { parameters: { id: this.oid } })
            : this.$fn.schemaDefaults('CreateProductPrice', {
                product_id: this.product.id, is_purchase_price: this.is_purchase_price
            });
    }
    currencies;
    async $$load_currencies() {
        return this.$fn.fetch('list_currency');
    }
    tariffs;
    async $$load_tariffs() {
        return this.$app.repo.get('list_object_by_type', { parameters: { object_type: 'tariff' } });
    }
    formName;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    labelAlign;
    isReadOnly;
    async $$load_isReadOnly() {
        return this.item.locked;
    }
    ux;
    b_7315092382398562_modalBindings;
    b_1879559807163442_dataSource;
    dataMembers = ['item', 'currencies', 'tariffs', 'formName', 'formId', 'labelAlign', 'isReadOnly', 'ux', 'b_7315092382398562_modalBindings', 'b_1879559807163442_dataSource'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: null,
                currencies: null,
                tariffs: null,
                formName: "productService",
                formId: null,
                labelAlign: "right",
                isReadOnly: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
                b_1879559807163442_dataSource: {
                    name: "suggest_company",
                    parameters: {
                        role: "partner",
                    },
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.oid ? this.$fn.gettext('Edit Price') : this.$fn.gettext('Add Price'),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_5450_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_5456_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                ok: true,
                value: $event.data.response.data,
            },
        };
    }
    async act_1040167445267876_request_5454_getActionArgs($event) {
        return {
            operation: this.item.id ? 'update_product_price' : 'create_product_price',
            data: this.item,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_2140198529698299_closeModal_5458_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async evh_2140198529698299_success(event, scope) {
        return await this.actions.evh_2140198529698299_success.executeFromDOM(this, event, scope);
    }
    async act_2434514588044777_closeModal_5460_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async evh_2434514588044777_success(event, scope) {
        return await this.actions.evh_2434514588044777_success.executeFromDOM(this, event, scope);
    }
    async act_2186679009640457_closeModal_5462_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                cancel: true,
            },
        };
    }
    async evh_2186679009640457_clickPreventStop(event, scope) {
        return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_5450 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_5450_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_5449 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_5450,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_5449],
        });
        const act_2248226175642056_closeComponent_5452 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_5451 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_5452,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_5451],
        });
        const act_1040167445267876_closeModal_5456 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_5456_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_5455 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_5456,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_request_5454 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_5454_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_success_5455],
        });
        const evh_1040167445267876_submit_5453 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_5454,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_5453],
        });
        const act_2140198529698299_closeModal_5458 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_2140198529698299_closeModal_5458_getActionArgs,
            events: [],
        });
        const evh_2140198529698299_success_5457 = new core_1.actions.EventHandlerImpl({
            action: act_2140198529698299_closeModal_5458,
            event: "success",
            displayName: "closeModal",
        });
        const evh_2140198529698299_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2140198529698299_success_5457],
        });
        const act_2434514588044777_closeModal_5460 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_2434514588044777_closeModal_5460_getActionArgs,
            events: [],
        });
        const evh_2434514588044777_success_5459 = new core_1.actions.EventHandlerImpl({
            action: act_2434514588044777_closeModal_5460,
            event: "success",
            displayName: "closeModal",
        });
        const evh_2434514588044777_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2434514588044777_success_5459],
        });
        const act_2186679009640457_closeModal_5462 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_2186679009640457_closeModal_5462_getActionArgs,
            events: [],
        });
        const evh_2186679009640457_clickPreventStop_5461 = new core_1.actions.EventHandlerImpl({
            action: act_2186679009640457_closeModal_5462,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_2186679009640457_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2186679009640457_clickPreventStop_5461],
        });
        return {
            act_7315092382398562_closeModal_5450,
            evh_7315092382398562_close_5449,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_5452,
            evh_2248226175642056_close_5451,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_5456,
            evh_1040167445267876_success_5455,
            act_1040167445267876_request_5454,
            evh_1040167445267876_submit_5453,
            evh_1040167445267876_submit,
            act_2140198529698299_closeModal_5458,
            evh_2140198529698299_success_5457,
            evh_2140198529698299_success,
            act_2434514588044777_closeModal_5460,
            evh_2434514588044777_success_5459,
            evh_2434514588044777_success,
            act_2186679009640457_closeModal_5462,
            evh_2186679009640457_clickPreventStop_5461,
            evh_2186679009640457_clickPreventStop,
            submit: act_1040167445267876_request_5454,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: null,
    }),
    __metadata("design:type", String)
], ProductPrice.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ProductPrice.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
        default: null,
    }),
    __metadata("design:type", Object)
], ProductPrice.prototype, "product", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('product'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ProductPrice.prototype, "onProduct", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], ProductPrice.prototype, "is_purchase_price", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('is_purchase_price'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ProductPrice.prototype, "onIs_purchase_price", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], ProductPrice.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ProductPrice.prototype, "onSize", null);
ProductPrice = __decorate([
    (0, vue_property_decorator_1.Component)()
], ProductPrice);
exports.default = ProductPrice;
vue_property_decorator_1.Vue.component("ProductPrice", ProductPrice);
